import { Component } from '@angular/core';
import { FastPaymentsService } from '../_services/fast-payments.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';
import { GhostButtonType } from 'src/app/shared/components/ghost-button/ghost-button-type.enum';
import { FastPayments } from '../_model/fast-payments.model';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { GhostButtonComponent } from 'src/app/shared/components/ghost-button/ghost-button.component';
import { InfoBoxComponent } from 'src/app/shared/components/info-box/info-box.component';

@Component({
  selector: 'app-payment-confirmation',
  standalone: true,
  imports: [
    CommonModule,
    GhostButtonComponent,
    TranslateModule,
    InfoBoxComponent
  ],
  templateUrl: './payment-confirmation.component.html',
  styleUrl: './payment-confirmation.component.scss'
})
export class PaymentConfirmationComponent {
  GhostButtonType: typeof GhostButtonType = GhostButtonType;
  status = 'accepted';
  content: any;
  authCode: string;
  id: string;
  waitingForData: boolean = false;
  system: string;
  paymentId: string;

  constructor(
    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private service: FastPaymentsService,
    private toastrService: ToastrService
  ) {
    this.id = this.route.snapshot.paramMap.get('id');
    this.system = this.route.snapshot.queryParamMap.get('system');

    if (this.id) {
      this.getPaymentStatusAndTranslationContent();
    } else {
      this.goToLink();
    }
  }

  getPaymentStatusAndTranslationContent() {
    this.service.getPaymentConfirmation(this.id, this.system).subscribe({
      next: (bill: FastPayments) => {
        this.authCode = bill.hotpConfirmation;
        this.status = bill.paymentStatus;
        this.paymentId = bill.paymentId?.id;
        this.translate
          .get(`FAST_PAYMENTS.CONFIRMATION.${this.status.toUpperCase()}`)
          .subscribe({
            next: (content) => (this.content = content)
          });
      },
      error: (error: { error: { detail: string } }) => {
        // customErrorHandler(error, this.toastrService, this.translate);
        this.toastrService.error(error?.error?.detail);

        setTimeout(() => {
          this.goToLink();
        }, 200)
      }
    });
  }

  goToLink() {
    this.router.navigate(['/'])
  }

  downloadPdf() {
    this.waitingForData = true;
    this.service.getPDF(this.paymentId, this.system).pipe(finalize(() => this.waitingForData = false)).subscribe({
      next: blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Potwierdzenie-${new Date(Date.now()).toLocaleString()}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: error => {
        console.error('Download error:', error);
      }
    });
  }
}
